import script from "./AdmissionNote.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmissionNote.vue?vue&type=script&setup=true&lang=js"

import "./AdmissionNote.vue?vue&type=style&index=0&id=3dc5edae&lang=css"

const __exports__ = script;

export default __exports__